import { IMenuItem } from "dots-ui/dotsMenuBar";
import {
  BlankMediaApplications,
  BlankMediaTypeApplicationPageRouter,
  LandingPageBlankMedia,
} from "../components/blankMedia";
import { LandingPageLicensees } from "../components/licensees/home/LandingPageLicensees";
import { InvoicesArchivePage } from "../components/licensees/invoices/InvoicesArchivePage";
import { InvoicesPage } from "../components/licensees/invoices/InvoicesPage";
import { LicenseReportDetailsPageRouter } from "../components/licensees/licenseReports/LicenseReportDetailsPageRouter";
import { LicenseReportsPage } from "../components/licensees/licenseReports/LicenseReportsPage";
import { ProgramReportPage } from "../components/licensees/licenseReports/components/programReport/ProgramReportPage";
import { LicenseView } from "../components/licensees/licenses/licenseView/LicenseView";
import { LicensesPage } from "../components/licensees/licenses/licensesGrid/LicensesPage";
import { ChangePasswordPage } from "../components/profile/ChangePasswordPage";
import { PublicBlankMediaView } from "../components/publicPortal/pages/PublicBlankMediaView";
import { PublicCreationsView } from "../components/publicPortal/pages/PublicCreationsView";
import { PublicRightsHoldersView } from "../components/publicPortal/pages/PublicRightsHoldersView";
import { BandsPage } from "../components/rightsHolder/bands/BandsPage";
import { BillingDataPage } from "../components/rightsHolder/billingData/BillingDataPage";
import { ContactInfoPage } from "../components/rightsHolder/contactInformation/ContactInfoPage";
import { CreationPageRouter } from "../components/rightsHolder/creations/creationView/CreationPageRouter";
import { CreationsNewPage } from "../components/rightsHolder/creations/creationViewNew/CreationsNewPage";
import { CreationsPage } from "../components/rightsHolder/creations/creationsList/CreationsPage";
import { DelegatedRightsPage } from "../components/rightsHolder/delegatedRights/DelegatedRightsPage";
import { LandingPageAuthors } from "../components/rightsHolder/home/LandingPageAuthors";
import { LinkedPersonsPage } from "../components/rightsHolder/linkedPersons/LinkedPersonsPage";
import { MemberStatusPage } from "../components/rightsHolder/memberStatus/MemberStatusPage";
import { NamesPage } from "../components/rightsHolder/names/NamesPage";
import { ReportsPage } from "../components/rightsHolder/reports/ReportsPage";
import {
  UnidentifiedCreationListPage,
  UnidentifiedCreationViewPage,
} from "../components/rightsHolder/unidentifiedCreations";
import { NotFoundPage } from "../components/shared/error/NotFoundPage";
import { NavigateUser } from "../components/shared/router/NavigateUser";
import {
  BlankMediaViewType,
  LicenseViewType,
  RightsHolderType,
} from "../models";
import { AuthorsUrls, BlankMediaUrls, LicenseesUrls } from "../utils";
import { AvisConstants } from "./avisConstants";

export type AvisRoute = {
  key: string;
  index?: boolean;
  path: string;
  element?: React.ReactNode | null;
  label?: string;
  tooltip?: string;
  exact?: boolean;
  icon?: string;
  children?: AvisRoute[];
  navItems?: IMenuItem[];
  // if undefined, then all types are allowed
  allowedRightsHolderTypes?: RightsHolderType[];
};
const urlPartLicensees = AvisConstants.url_part_portal_licensees;
const urlPartBlankMedia = AvisConstants.url_part_portal_blank_media;

export const verticalNavbarItems_Authors: IMenuItem[] = [
  {
    key: "landing",
    label: "Sākums",
    url: AuthorsUrls.rightsHoldersPortal,
  },
  {
    key: "title-1",
    label: "Tiesību īpašnieka dati",
    title: true,
  },
  {
    key: "names",
    label: "Vārdi un pseidonīmi",
    url: AuthorsUrls.rightsHoldersNames,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "bands",
    label: "Izpildītāju grupas",
    url: AuthorsUrls.rightsHoldersBands,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "contacts-info",
    label: "Kontaktinformācija",
    url: AuthorsUrls.rightsHoldersContacts,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "linked-persons",
    label: "Saistītās personas",
    url: AuthorsUrls.rightsHoldersLinkedPersons,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "delegated-rights",
    label: "Deleģētās tiesības",
    url: AuthorsUrls.rightsHoldersDelegatedRights,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "billing-data",
    label: "Norēķinu dati",
    url: AuthorsUrls.rightsHoldersBillingData,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "member-status",
    label: "Biedra statuss",
    url: AuthorsUrls.rightsHoldersMemberStatus,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "reports",
    label: "Pārskati",
    url: AuthorsUrls.rightsHoldersReports,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "title-2",
    label: "Radošie darbi",
    title: true,
  },
  {
    key: "creations-page",
    label: "Darbu katalogs",
    url: AuthorsUrls.rightsHoldersCreations,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "creations-new",
    label: "Reģistrēt jaunu darbu",
    url: AuthorsUrls.rightsHoldersCreationViewNew,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "unidentified-creations",
    label: "Neatpazītie darbi",
    url: AuthorsUrls.rightsHoldersCreationUnidentifiedList,
    className: "avis-vertical-bar-submenu-item",
  },
];
export const verticalNavbarItems_Licensees: IMenuItem[] = [
  {
    key: "licensees-landing",
    label: "Sākums",
    url: `/${urlPartLicensees}`,
  },
  {
    key: "title-1",
    label: "Licences",
    title: true,
  },
  {
    key: "licensees-licenses",
    label: "Aktuālās licences",
    url: `/${urlPartLicensees}/licenses`,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "licensees-licenses-completed",
    label: "Licenču arhīvs",
    url: `/${urlPartLicensees}/licenses/completed`,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "title-2",
    label: "Rēķini",
    title: true,
  },
  {
    key: "licensees-invoices",
    label: "Rēķini apmaksai",
    url: `/${urlPartLicensees}/invoices`,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "licensees-invoices-arhcive",
    label: "Rēķinu arhīvs",
    url: `/${urlPartLicensees}/invoice-archive`,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "title-2",
    label: "Atskaites",
    title: true,
  },
  {
    key: "licensees-reports",
    label: "Aktuālās atskaites",
    url: `/${urlPartLicensees}/reports`,
    className: "avis-vertical-bar-submenu-item",
  },
];
export const verticalNavbarItems_BlankMedia: IMenuItem[] = [
  {
    key: "blank-media-landing",
    label: "Sākums",
    url: `/${urlPartBlankMedia}`,
  },
  {
    key: "blank-media-title-documents",
    label: "Dokumenti",
    title: true,
  },
  {
    key: "blank-media-applications",
    label: "Iesniegumi",
    url: `/${urlPartBlankMedia}/applications`,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "blank-media-title-new-applications",
    label: "Jauns iesniegums",
    title: true,
  },
  {
    key: "blank-media-application-new-i",
    label: "Ievedējiem / Izgatavotājiem",
    url: BlankMediaUrls.applicationViewNewI,
    className: "avis-vertical-bar-submenu-item",
  },
  {
    key: "blank-media-application-new-p",
    label: "Prof. lietotājiem",
    url: BlankMediaUrls.applicationViewNewP,
    className: "avis-vertical-bar-submenu-item",
  },
];
export const avisRoutes: AvisRoute[] = [
  {
    key: "root",
    path: `/`,
    element: <NotFoundPage />,
  },
  {
    key: "redirect",
    path: AuthorsUrls.rightsHoldersPortal,
    element: <NavigateUser />,
  },
  {
    key: "contacts-info",
    path: AuthorsUrls.rightsHoldersContacts,
    element: <ContactInfoPage />,
    navItems: verticalNavbarItems_Authors,
  },
  {
    key: "change-password",
    path: `${AuthorsUrls.rightsHoldersPortal}${AvisConstants.url_change_password}`,
    element: <ChangePasswordPage />,
    navItems: verticalNavbarItems_Authors,
  },
  {
    key: "landing",
    path: AuthorsUrls.rightsHoldersPortalHome,
    element: <LandingPageAuthors />,
    navItems: verticalNavbarItems_Authors,
  },
  {
    key: "names",
    path: AuthorsUrls.rightsHoldersNames,
    element: <NamesPage />,
    navItems: verticalNavbarItems_Authors,
  },
  {
    key: "bands",
    path: AuthorsUrls.rightsHoldersBands,
    element: <BandsPage />,
    navItems: verticalNavbarItems_Authors,
    allowedRightsHolderTypes: [
      RightsHolderType.Author,
      RightsHolderType.CooperationPartner,
      RightsHolderType.SisterOrganization,
    ],
  },
  {
    key: "linked-persons",
    path: AuthorsUrls.rightsHoldersLinkedPersons,
    element: <LinkedPersonsPage />,
    navItems: verticalNavbarItems_Authors,
    allowedRightsHolderTypes: [
      RightsHolderType.Author,
      RightsHolderType.CooperationPartner,
      RightsHolderType.SisterOrganization,
    ],
  },
  {
    key: "delegated-rights",
    path: AuthorsUrls.rightsHoldersDelegatedRights,
    element: <DelegatedRightsPage />,
    navItems: verticalNavbarItems_Authors,
  },
  {
    key: "billing-data",
    path: AuthorsUrls.rightsHoldersBillingData,
    element: <BillingDataPage />,
    navItems: verticalNavbarItems_Authors,
  },
  {
    key: "member-status",
    path: AuthorsUrls.rightsHoldersMemberStatus,
    element: <MemberStatusPage />,
    navItems: verticalNavbarItems_Authors,
  },
  {
    key: "reports",
    path: AuthorsUrls.rightsHoldersReports,
    element: <ReportsPage />,
    navItems: verticalNavbarItems_Authors,
  },
  {
    key: "creations-page",
    path: AuthorsUrls.rightsHoldersCreations,
    element: <CreationsPage />,
    navItems: verticalNavbarItems_Authors,
  },
  {
    key: "creation-page-router",
    path: AuthorsUrls.rightsHoldersCreationView,
    element: <CreationPageRouter />,
    navItems: verticalNavbarItems_Authors,
  },
  {
    key: "creations-new",
    path: AuthorsUrls.rightsHoldersCreationViewNew,
    element: <CreationsNewPage defaultCreationType="M" />,
    navItems: verticalNavbarItems_Authors,
  },
  {
    key: "unidentified-creations",
    path: AuthorsUrls.rightsHoldersCreationUnidentifiedList,
    element: <UnidentifiedCreationListPage />,
    navItems: verticalNavbarItems_Authors,
  },
  {
    key: "unidentified-creations-card",
    path: AuthorsUrls.rightsHoldersCreationUnidentifiedView,
    element: <UnidentifiedCreationViewPage />,
    navItems: verticalNavbarItems_Authors,
  },
  // Licensees
  {
    key: "licensees-landing",
    path: `/${urlPartLicensees}`,
    element: <LandingPageLicensees />,
    navItems: verticalNavbarItems_Licensees,
  },
  {
    key: "licensees-licenses",
    path: `/${urlPartLicensees}/licenses`,
    element: <LicensesPage key="actual" textKey="portal_LIC_ActiveLicenses" />,
    navItems: verticalNavbarItems_Licensees,
  },
  {
    key: "licensees-licenses-completed",
    path: `/${urlPartLicensees}/licenses/completed`,
    element: (
      <LicensesPage
        key="completed"
        textKey="portal_LIC_CompletedLicenses"
        completed
      />
    ),
    navItems: verticalNavbarItems_Licensees,
  },
  {
    key: "licensees-license-view",
    path: LicenseesUrls.licenseeLicenseView,
    element: <LicenseView viewType={LicenseViewType.Reports} />,
    navItems: verticalNavbarItems_Licensees,
  },
  {
    key: "licensees-licenses-view-child-licenses",
    path: LicenseesUrls.licenseeLicenseViewChildLicenses,
    element: <LicenseView viewType={LicenseViewType.Grouped} />,
    navItems: verticalNavbarItems_Licensees,
  },
  {
    key: "licensees-licenses-view-invoices",
    path: LicenseesUrls.licenseeLicenseViewInvoices,
    element: <LicenseView viewType={LicenseViewType.Invoices} />,
    navItems: verticalNavbarItems_Licensees,
  },
  {
    key: "licensees-licenses-view-report",
    path: LicenseesUrls.licenseeLicenseViewReport,
    element: <LicenseReportDetailsPageRouter />,
    navItems: verticalNavbarItems_Licensees,
  },
  {
    key: "licensees-licenses-view-report-program",
    path: LicenseesUrls.licenseeLicenseViewReportPP,
    element: <ProgramReportPage />,
    navItems: verticalNavbarItems_Licensees,
  },
  {
    key: "licensees-invoices",
    path: `/${urlPartLicensees}/invoices`,
    element: <InvoicesPage />,
    navItems: verticalNavbarItems_Licensees,
  },
  {
    key: "licensees-invoices-arhcive",
    path: `/${urlPartLicensees}/invoice-archive`,
    element: <InvoicesArchivePage />,
    navItems: verticalNavbarItems_Licensees,
  },
  {
    key: "licensees-reports",
    path: `/${urlPartLicensees}/reports`,
    element: <LicenseReportsPage textKey="portal_LIC_OverdueReports" />,
    navItems: verticalNavbarItems_Licensees,
  },
  {
    key: "licensees-change-password",
    path: `/${urlPartLicensees}${AvisConstants.url_change_password}`,
    element: <ChangePasswordPage />,
    navItems: verticalNavbarItems_Licensees,
  },

  //blank-media portal
  {
    key: "blank-media-landing",
    path: `/${urlPartBlankMedia}`,
    element: <LandingPageBlankMedia />,
    navItems: verticalNavbarItems_BlankMedia,
  },
  {
    key: "blank-media-applications",
    path: BlankMediaUrls.applicationsList,
    element: <BlankMediaApplications />,
    navItems: verticalNavbarItems_BlankMedia,
  },
  {
    key: "blank-media-application-view",
    path: BlankMediaUrls.applicationViewWithId,
    element: <BlankMediaTypeApplicationPageRouter />,
    navItems: verticalNavbarItems_BlankMedia,
  },
  {
    key: "blank-media-application-new-i",
    path: BlankMediaUrls.applicationViewNewI,
    element: <BlankMediaTypeApplicationPageRouter />,
    navItems: verticalNavbarItems_BlankMedia,
  },
  {
    key: "blank-media-application-new-p",
    path: BlankMediaUrls.applicationViewNewP,
    element: <BlankMediaTypeApplicationPageRouter />,
    navItems: verticalNavbarItems_BlankMedia,
  },
  {
    key: "blank-media-change-password",
    path: `/${urlPartBlankMedia}${AvisConstants.url_change_password}`,
    element: <ChangePasswordPage />,
    navItems: verticalNavbarItems_BlankMedia,
  },

  // Public
  {
    key: "public-blank-media-importers",
    path: `/common/blank-media/importers`,
    element: (
      <PublicBlankMediaView
        viewType={BlankMediaViewType.Importer}
        textToDisplay="portal_PUBL_ImporterList"
        titleKey="public_BlankMedia_Importers_Title"
      />
    ),
  },
  {
    key: "public-blank-media-manufacturers",
    path: `/common/blank-media/manufacturers`,
    element: (
      <PublicBlankMediaView
        viewType={BlankMediaViewType.Manufacturer}
        textToDisplay="portal_PUBL_ProducerList"
        titleKey="public_BlankMedia_Manufacturers_Title"
      />
    ),
  },
  {
    key: "public-blank-media-professional-users",
    path: `/common/blank-media/professional-users`,
    element: (
      <PublicBlankMediaView
        viewType={BlankMediaViewType.ProfessionalUser}
        textToDisplay="portal_PUBL_ProfesionalList"
        titleKey="public_BlankMedia_Professionals_Title"
      />
    ),
  },
  {
    key: "public-creations",
    path: `/common/creations`,
    element: <PublicCreationsView />,
  },
  {
    key: "public-rights-holders",
    path: `/common/rights-holders`,
    element: <PublicRightsHoldersView />,
  },
];
